import React from 'react';
import { Palette } from 'lucide-react';

/**
 * DesignNoBadge — small clickable RD badge shown on order cards / rows.
 * Clicking filters the Order Forms list to every order on that design
 * (opens in a new tab). Distinct violet tone so it never visually collides
 * with the (indigo) Reference/Page-No chip beside it.
 */
export function DesignNoBadge({ designNo, className = '', testId }) {
  if (!designNo) return null;
  const open = (e) => {
    if (e) { e.stopPropagation(); e.preventDefault(); }
    window.open(`/orders?design_no=${encodeURIComponent(designNo)}`, '_blank', 'noopener,noreferrer');
  };
  return (
    <span
      role="button"
      tabIndex={0}
      onClick={open}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') open(e); }}
      title={`Show all orders on design ${designNo} (new tab)`}
      data-testid={testId || `design-no-badge-${designNo}`}
      className={`inline-flex items-center gap-0.5 font-mono text-[11px] bg-violet-50 text-violet-700 border border-violet-200 px-1.5 py-0.5 rounded cursor-pointer hover:bg-violet-100 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--gold-accent)] ${className}`}
    >
      <Palette size={10} />
      {designNo}
    </span>
  );
}

export default DesignNoBadge;
